// LOADER ************************************************************************************
/*********************************************************************************************
 * Add a loading state to the specified button.
 *
 * @param {HTMLElement} elem - The element to which the 'mm-loading' class will be added.
 */
const mmLoadThis = (elem) => elem.classList.add("mm-loading");

// MEGAMENU **********************************************************************************
/*********************************************************************************************
 * Hide specified elements and show the specified element.
 *
 * @param {string} classElemsToHide - The CSS selector for the elements to hide.
 * @param {string} classElemToShow - The CSS selector for the element to show.
 */
const mmMegaMenuShowProducts = (classElemsToHide, classElemToShow) => {
	document.querySelectorAll(classElemsToHide).forEach((elem) => (elem.style.display = "none"));
	document.querySelector(classElemToShow).style.display = "grid";
};

/*********************************************************************************************
 * Adjust the position of the mega menu based on the header height.
 *
 */
const getMegaMenuPosition = () => {
	const header = document.querySelector("[data-mm-header]");
	if (!header) return;

	const headerHeight = header.offsetHeight;
	document.querySelectorAll("[data-megamenulink]").forEach((menuElem) => {
		const megaMenu = menuElem.nextElementSibling;
		if (megaMenu?.hasAttribute("data-megamenu")) {
			megaMenu.style.top = `${headerHeight - 1}px`;
		}
	});
};

// BACKGROUND FILTER *************************************************************************
/*********************************************************************************************
 * Add background filter on hover over mega menu links.
 *
 */
const hoverBgFilter = () => {
	const header = document.querySelector("[data-mm-header]");
	const searchContainer = document.querySelector("[data-search-container]");
	const megaMenuLinks = document.querySelectorAll("[data-megamenulink]");
	const menuLinks = document.querySelectorAll("[data-menulink]");
	const filter = document.querySelector("[data-filter]");
	const cart = document.querySelector("[data-cart-filter]");

	if (!header || !filter || !cart) return;

	const toggleFilter = (show) => {
		filter.classList.toggle("active", show);
	};

	megaMenuLinks.forEach((link) => link.addEventListener("mouseenter", () => toggleFilter(true)));
	menuLinks.forEach((link) => link.addEventListener("mouseenter", () => toggleFilter(false)));

	header.addEventListener("mouseleave", () => {
		if ((!searchContainer || !searchContainer.classList.contains("mm-open")) && !cart.classList.contains("mm-dc-is-open")) {
			toggleFilter(false);
		}
	});
};

/*********************************************************************************************
 * Show background filter.
 *
 */
const showBgFilter = (zIndex) => {
	const filter = document.querySelector("[data-filter]");
	if (!filter) return;
	filter.classList.add("active");
	if (zIndex) filter.style.zIndex = zIndex;
};

/*********************************************************************************************
 * Hide background filter.
 *
 */
const hideBgFilter = () => {
	const filter = document.querySelector("[data-filter]");
	if (!filter) return;
	setTimeout(() => filter.style.removeProperty("z-index"), 700);
	filter.classList.remove("active");
};

// EXTERNAL LINK *****************************************************************************
/*********************************************************************************************
 * Open external links in a new tab unless it's the consent modale.
 *
 */
const externalLink = () => {
	document.querySelectorAll("a:not(.consent-wrapper)").forEach((link) => {
		if (link.hostname !== window.location.hostname) {
			link.target = "_blank";
			link.rel = "noreferrer noopener";
		}
	});
};

// MENU MOBILE *******************************************************************************
/*********************************************************************************************
 * Toggle the mobile menu.
 *
 */
const mmMobileMenu = () => {

	if (window.innerWidth > 1024) return;

	const elements = {
		header: document.querySelector("header"),
		icon: document.querySelector("[data-header-burger]"),
		mobileMenu: document.querySelector("[data-menu-mobile]"),
		mobileMenuSecondary: document.querySelector("[data-menu-sublinks]"),
		headerMenu: document.querySelector("[data-mm-header]"),
		html: document.documentElement,
	};

	const { header, icon, mobileMenu, mobileMenuSecondary, headerMenu, html } = elements;

	const headerHeight = headerMenu.offsetHeight;
	const headerMenuTop = headerMenu.getBoundingClientRect().top;
	const topPosition = `${headerHeight + headerMenuTop}px`;
	const heightCalc = `calc(var(--doc-height) - ${topPosition})`;

	[header, icon, mobileMenu].forEach((el) => el.classList.toggle("mm-open"));
	html.classList.add("stop-scrolling");

	Object.assign(mobileMenu.style, { top: topPosition, height: heightCalc });
	mobileMenuSecondary.style.height = heightCalc;

	showBgFilter("var(--index-lg)");
};

/*********************************************************************************************
 * Close the mobile menu.
 *
 */
const mmCloseMobileMenu = (keepFilterActive = false) => {
	if (window.innerWidth > 1024) return;

	const elements = {
		header: document.querySelector("header"),
		icon: document.querySelector("[data-header-burger]"),
		mobileMenu: document.querySelector("[data-menu-mobile]"),
		html: document.querySelector("html"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { header, icon, mobileMenu, html } = elements;

	
	[header, icon, mobileMenu].forEach((el) => el.classList.remove("mm-open"));
	html.classList.remove("stop-scrolling");

	if (!keepFilterActive) hideBgFilter();

	setTimeout(() => {
	document.querySelector('.mm-mega-menu-mobile-container').classList.remove('mm-open');
	}, 300);
};

/*********************************************************************************************
 * Show the next sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
const mmMobileMenuShowNext = (elemToShowClass) => {
	document.querySelector(elemToShowClass)?.classList.add("mm-mobile-menu-elem-slided");
};

/*********************************************************************************************
 * Show the previous sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
const mmMobileMenuShowPrev = (elemToShowClass) => {
	document.querySelector(elemToShowClass)?.classList.remove("mm-mobile-menu-elem-slided");
};

// DROPDOWN **********************************************************************************
/*********************************************************************************************
 * Handle dropdown behavior.
 *
 */
const handleDropdown = () => {
	const dropWrappers = document.querySelectorAll('[data-drop="dropdown"]');

	dropWrappers.forEach((item) => {
		item.addEventListener("click", function () {
			dropWrappers.forEach((el) => {
				if (el !== this) {
					el.classList.remove("active");
					if (el.nextElementSibling) el.nextElementSibling.style.maxHeight = null;
				}
			});

			this.classList.toggle("active");
			const content = this.nextElementSibling;

			if (content) {
				content.style.maxHeight = this.classList.contains("active") ? `${content.scrollHeight}px` : null;
			}
		});
	});

	
    // Dropdowns multiples (plusieurs ouverts possibles)
    const dropWrappers2 = document.querySelectorAll('[data-drop="dropdown-2"]');
    dropWrappers2.forEach((item) => {
        // Vérifie s'il est actif au chargement
        const content = item.nextElementSibling;
        if (item.classList.contains('active') && content) {
            content.style.maxHeight = `${content.scrollHeight}px`;
        }

        item.addEventListener('click', function () {
            // Toggle l'élément actuel uniquement
            this.classList.toggle('active');
			
            const content = this.nextElementSibling;

            if (content) {
				
                content.style.maxHeight = this.classList.contains('active') ? `${content.scrollHeight}px` : null;
            }
        });
    });
};

// SEARCH ************************************************************************************
/*********************************************************************************************
 * Show the search bar and related UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to show the search bar.
 */
const mmShowSearch = () => {
	const elements = {
		search: document.querySelector("[data-search-container]"),
		html: document.documentElement,
		searchInput: document.getElementById("Search"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { search, html, searchInput } = elements;

	html.classList.add("stop-scrolling");
	search.classList.add("mm-open");
	showBgFilter();

	setTimeout(() => searchInput.focus(), 1000);

	document.getElementById("predictive-search")?.addEventListener("touchstart", () => {
		setTimeout(() => searchInput.blur(), 500);
	});
};

/*********************************************************************************************
 * Hide the search bar and revert UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to hide the search bar.
 */
const mmHideSearch = (keepFilterActive = false, keepStopScrolling = false) => {
	const elements = {
		search: document.querySelector("[data-search-container]"),
		html: document.documentElement,
		searchInput: document.getElementById("Search"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { search, html, searchInput } = elements;
	// console.log(keepStopScrolling);
	if (!keepStopScrolling) {
		html.classList.remove("stop-scrolling");
	}
	search.classList.remove("mm-open");
	if (!keepFilterActive) hideBgFilter();

	searchInput.value = "";
	searchInput.dispatchEvent(new Event("input"));
};

/*********************************************************************************************
 * Handles lazy loading of videos based on viewport size
 *
 */
const mmInitVideoLazy = () => {
	const videos = document.querySelectorAll(".mm-video-lazy");
	if (!videos.length) return;

	const loadVideo = (video) => {
		if (video.dataset.loaded !== "true") {
			const source = video.querySelector("source");
			if (!source || !source.dataset.src) return;

			source.src = source.dataset.src;
			video.preload = "metadata";
			video.dataset.loaded = "true";

			video.load();
			video.play().catch((err) => console.warn("Auto-play failed:", err));
		}
	};

	const unloadVideo = (video) => {
		if (video.dataset.loaded === "true") {
			video.pause();
			video.currentTime = 0;
			video.dataset.loaded = "false";
		}
	};

	const handleVideoVisibility = (video) => {
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		const isDesktop = video.classList.contains("mm-desktop");
		const isMobileVideo = video.classList.contains("mm-mobile");

		const shouldPlay = (!isDesktop && !isMobileVideo) || (isDesktop && !isMobile) || (isMobileVideo && isMobile);

		if (shouldPlay) {
			loadVideo(video);
			video.classList.add("mm-video-loaded");
		} else {
			video.classList.remove("mm-video-loaded");
		}
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					handleVideoVisibility(entry.target);
				} else {
					unloadVideo(entry.target);
				}
			});
		},
		{
			rootMargin: "50px 0px",
			threshold: 0.1,
		}
	);

	videos.forEach((video) => observer.observe(video));

	let resizeTimeout;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			videos.forEach((video) => {
				if (video.classList.contains("mm-video-loaded")) {
					handleVideoVisibility(video);
				}
			});
		}, 250);
	});
};

/*********************************************************************************************
 * Set the document height CSS variable to the current window height.
 *
 */
const documentHeight = () => {
	document.documentElement.style.setProperty("--doc-height", `${window.innerHeight}px`);
};

/*********************************************************************************************
 * Custom element for product recommendations
 *
 */
// class ProductRecommendations extends HTMLElement {
// 	constructor() {
// 		super();
// 	}

// 	connectedCallback() {
// 		const handleIntersection = (entries, observer) => {
// 			if (!entries[0].isIntersecting) return;
// 			observer.unobserve(this);

// 			fetch(this.dataset.url)
// 				.then((response) => response.text())
// 				.then((text) => {
// 					const html = document.createElement("div");
// 					html.innerHTML = text;
// 					const recommendations = html.querySelector("product-recommendations");

// 					if (recommendations && recommendations.innerHTML.trim().length) {
// 						this.innerHTML = recommendations.innerHTML;
// 						// Réinitialiser la wishlist pour les nouvelles cartes de produits
// 						if (window.wishlistManager) {
// 							window.wishlistManager.initButtons();
// 						}
// 					} else {
// 						const parentElement = this.closest(".mm-section");
// 						if (parentElement) {
// 							parentElement.style.display = "none";
// 						}
// 					}
// 				})
// 				.catch((e) => {
// 					console.error(e);
// 				});
// 		};

// 		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
// 	}
// }

// customElements.define("product-recommendations", ProductRecommendations);


/*********************************************************************************************
 * Fonction pour splide
 */
/*********************************************************************************************
 * Fonction principale exécutée après le chargement du DOM
 */
function initializeSectionsWithSplide(attributeName, className, initializeFunction) {
    const sections = document.querySelectorAll(`[${attributeName}]`);

    sections.forEach(function (section) {
        const splideElem = section.querySelector(className);

        if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
            // Appel dynamique de la fonction passée en paramètre
            initializeFunction(splideElem, section); 
        }
    });
}

/*********************************************************************************************
 * Fonction pour gérer le défilement horizontal
 */
function addHorizontalScrollListener(splideElem, splideInstance) {
    let scrollCounter = 0;

    splideElem.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            return;
        }

        e.preventDefault();

        scrollCounter++;

        if (scrollCounter >= 12) {
            scrollCounter = 0;

            if (e.deltaX < 0) {
                splideInstance.go('<'); 
            } else if (e.deltaX > 0) {
                splideInstance.go('>'); 
            }
        }
    });
}


// DOM ***************************************************************************************
/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	getMegaMenuPosition();
	hoverBgFilter();
	externalLink();
	handleDropdown();
	documentHeight();
	mmInitVideoLazy();
});

/*********************************************************************************************
 * Resized Listenner
 *
 */
window.addEventListener("resize", () => {
	getMegaMenuPosition();
	documentHeight();
});